// ALL Apis 
//----------------------Login resigter
export const login = { api:"Token", method:"POST" }

export const GetToken = { api:"token/createtoken", method:"POST" }

export const resetPasswordApi = { api:"Account/ResetPasswordToken", method:"POST" }

export const resetPasswordTokenApi = { api:"Account/ResetPasswordTokenWOE", method:"POST" }

export const resetPasswordUpdateApi = { api:"Account/ResetPassword", method:"POST" }

export const confirmPasswordChangedApi = {
    url: 'Account/ConfirmPasswordChanged?',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "GET"
}

export const registerApi = { api:"Account/Register", method:"POST" }

export const listNotificationApi = { api:"Notification/GetNotifications", method:"GET" }

export const readNotificationApi = { api:"notification/updatenotification", method:"POST" }

// Center Team
// ---------------------raw Dump

// Work Order Delete By Month API - https://uatest.in/api/Admin/DeleteWorkOrderByMonth?month=9&year=2022

export const rawDumpDeleteApi = {
    url: 'Admin/DeleteWorkOrderByMonth?month=',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "POST"
}

export const rawFileUploadApi = { api:"file", formData: null}
//----------------new call for file insert in server(rawdump only)
export const rawDumpFileUploadApi = {api:"RawDump", formData: null}

export const rawFileInsertApi = { api:"Excel/ExcelImport",  method:"POST"}

export const dumpImportApi = { api:"Import/WOImportAndProcess", method:"POST"}

export const poImportApi = { api:"Import/ImportAndProcessPurchaseOrder", method:"POST"}

export const gradationImportApi = { api:"import/ImportAndProcessGradation", method:"POST" }

export const ppiProductUploadApi = { api:"admin/UploadPPIProduct", method:"POST" }
export const hbnProductUploadApi = { api:"admin/UploadHBNProduct", method:"POST" }
export const coolingProductUploadApi = { api:"admin/UploadCoolingProduct", method:"POST" }

export const paymentUpdateApi = { 
    url: 'Invoice/SetStatusByExcel?',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "GET"
}

export const listAllRawDumpApi = {
    url: 'WorkOrder/GetList?Month=',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "GET"
}

export const UpdateRawDumpApi = {
    url: 'WorkOrder/SetStatus?',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "GET"
}
// CSS Team
// --------------------------Get Work Order List CSS in Manager
export const defaultPasswordSetApi = { api:"Admin/DefaultPassword", method:"POST" }

export const listAllWorkOrderCSSApi = {
    url: 'WorkOrder/GetListByCSS?Month=',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "GET"
}

export const listInvoiceCSSApi = {
    url: 'Invoice/GetInvoices?BusinessUnit=',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "GET"
}

export const cssRasieInvoice = { api:"Invoice/SetInvoiceStatus", method:"POST" }

export const cssCurrentStatus = {
    url: 'CurrentStatus/GetCurrentStatus?',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "GET"
}

export const cssGradationApi = { api:"Gradation/GetGradationList", method:"GET" }

export const listAllApprovedApi = {
    url: 'ApprovedData/GetApprovedData?',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "GET"
}

// --------------------Reports
export const listAllReportApi = {
    url: 'report/',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "GET"
}

export const listRegionApi = { api:"report/GetRegion", method:"GET" }


// -------------------Invoice Due

export const noDueListApi = { api:"invoice/GetNoDueInvoices", method:"GET" }  

export const noDueInvoiceSetApi = { api:"invoice/setnoduedate", method:"POST" } 

export const noDueApi = {
    url: 'Nodue/sendnodue?filename=',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "GET"
}

// ----------------------Admin apis

export const listAllUserApi = { api:"Admin/ListUsers", method:"GET" }

export const listUserApi = { api:"admin/getusers", method:"GET" }

export const listCSSUserApi = { api:"admin/getcsslist", method:"GET" }

export const deleteUserApi = { api:"admin/deleteuser", method:"POST" }

export const userCreatApi = { api:"admin/createuser", method:"POST" }

export const updateCSSApi = { api:"admin/updatecss", method:"POST" }  

export const uploadCSSApi = { api:"admin/uploadcss", method:"POST" }

// ----------------------Dashboard apis

export const gradationDashboardApi = {
    url: 'dashboard/GetGradation?',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "GET"
}

export const paymentDashboardApi = {
    url: 'dashboard/GetPaymentByCount?',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "GET"
}

export const paymentDashboardValueApi = {
    url: 'dashboard/GetPaymentByValue?',
    params: '',
    status: true,
    get api() {
        return this.url + this.params
    },
    set addOffset(params) {
        this.params = params
    },
    method: "GET"
}

export const purchaseOrderDashboardApi = { api:"dashboard/GetPurchaseOrder", method:"GET" }

// ------------------------admin product 

export const adminProductApi = { api:"admin/GetProductCategoryList", method:"GET"}

// -----------update
export const updateProductPPIApi = { api:"admin/UpdatePPIProduct", method:"POST" }
 
export const updateProductHBNApi = { api:"admin/UpdateHBNProduct", method:"POST" }

export const updateProductCoolingApi = { api:"admin/UpdateCoolingProduct", method:"POST" }

// -------------create
export const createProductPPIApi = { api:"admin/InsertPPIProduct", method:"POST" }
 
export const createProductHBNApi = { api:"admin/InsertHBNProduct", method:"POST" }

export const createProductCoolingApi = { api:"admin/InsertCoolingProduct", method:"POST" }

// --------------central file upload list

export const woGetPreviousMonthsApi = { api:"WorkOrder/GetPreviousMonths", method:"GET"}